import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://apieoffice.bpdp.or.id/images/sawit.jpg',
    drawer: null,
    user: null
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_USER(state, payload) {
      state.user = payload
    },
    CLEAR_USER(state) {
      state.user = null
    }
  },
  actions: {

  },
})
